module.exports = __webpack_public_path__ + "img/mobileDownload.8db3d7b7.svg";